// extracted by mini-css-extract-plugin
export default {"map":"Contact_map__0MaB1","bioContacts":"Contact_bioContacts__JFQna"};